import blenderLogo from "../assets/icons/BlenderLog.svg";
import substancePainterLogo from "../assets/icons/SubstancePainterLogo.svg";
import photoshopLogo from "../assets/icons/PhotoshopLogo.svg";
import mayaLogo from "../assets/icons/MayaLogo.svg";

export const skills = [
  {
    skillSet: [
        "Blender",
        "Substance Painter",
        "Photoshop",
        "Maya",
        "Hard Surface Modeling",
        "3D sculpting",
        "Texturing",
        "Rigging",
        "Animation",
        "UV Mapping",
        "PBR Workflow",
        "3D Asset Optimization",
        "Realistic Modeling",
        "Machine Design",
        "Clean Topology",
    ],

    skillIcons: [
        blenderLogo,
        substancePainterLogo,
        photoshopLogo,
        mayaLogo,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
    ]
  }
];
